<div
    class="agpr-recentActivities"
    [agprLoading]="loading"
    [ngClass]="{'agpr-recentActivities-loading': loading}"
    [id]="id + '.recentActivities'"
>
    <div class="agpr-recentActivities-header">
        <span class="agpr-recentActivities-header-label">
            {{'LandingPage.main.recentActivities.header'|localize}}
        </span>
        @if (showToggleButton) {
            <agpr-button
                [id]="id + '.recentActivities' + '.toggle'"
                class="agpr-recentActivities-header-toggleButton"
                [label]="toggleTitle"
                [style]="buttonTypes.textToggle"
                (click)="toggleView()"
            ></agpr-button>
        }
    </div>
    <div
        class="agpr-recentActivities-container"
    >
        @if (hasContent) {
            <p-carousel
                #carousel
                [value]="carouselValue"
                [numVisible]="defaultNumVisible"
                [numScroll]="defaultNumVisible"
                [circular]="false"
                [responsiveOptions]="responsiveOptions"
                [showIndicators]="true"
                [showNavigators]="true"
                [id]="id + '.recentActivities' + '.carousel'"
            >
                <ng-template pTemplate="item" let-activity>
                        <div class="agpr-recentActivities-cards">
                            <a
                                class="agpr-recentActivities-item-link"
                                [routerLink]="activity.route"
                                [queryParams]="{ filters: activity.filters }"
                            >
                                <div class="agpr-recentActivities-item">
                                    <div class="agpr-recentActivities-item-header">
                                        <span class="{{activity.headerIcon}} agpr-recentActivities-item-headerIcon"></span>
                                        <span class="agpr-recentActivities-item-headerContent">
                                            {{ activity.header | localize }}
                                        </span>
                                    </div>
                                    <div class="agpr-recentActivities-item-container">
                                        <div class="agpr-recentActivities-item-title">
                                            <span>{{ activity.title }}</span>
                                        </div>
                                        <div class="agpr-recentActivities-item-date">
                                            {{ activity.date }}
                                        </div>
                                        <div class="agpr-recentActivities-item-chip">
                                            <agpr-chip-container
                                                [chips]="[activity.status]"
                                                readonly="true"
                                                noTooltips="true"
                                                [id]="id + '.recentActivities' + activity.header + activity.id + '_chips'"
                                            ></agpr-chip-container>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                </ng-template>
            </p-carousel>
        }@else {
            @if (!loading) {
                <agpr-message
                    class="agpr-recentActivities-message"
                    [icon]="'fa-duotone fa-light fa-rocket-launch'"
                    [id]="id + '.recentActivities' + '.message'"
                >
                    <span class="agpr-recentActivities-message-header">{{ 'LandingPage.main.recentActivities.noContent.header' | localize }}</span>
                    @if (selectedViewMode === 'account') {
                        <span class="agpr-recentActivities-message-subheader">
                            {{
                                'LandingPage.main.recentActivities.account.noContent.subHeader' | localize
                            }}
                        </span>
                        <span class="agpr-recentActivities-message-subheaderTips">
                            {{
                                'LandingPage.main.recentActivities.account.noContent.subHeaderTips' | localize
                            }}
                        </span>
                    }@else {
                        <span class="agpr-recentActivities-message-subheader">
                            {{
                                'LandingPage.main.recentActivities.user.noContent.subHeader' | localize
                            }}
                        </span>
                        <span class="agpr-recentActivities-message-subheaderTips">
                            {{
                                'LandingPage.main.recentActivities.account.noContent.subHeaderTips' | localize
                            }}
                        </span>
                    }
                </agpr-message>
            }
        }
    </div>
</div>
